import { isFromBreakpoint } from '~/breakpoints';
import { HTMLCustomElement } from '~/html-custom-element';

if (!customElements.get('product-gallery'))
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLCustomElement {
      connectedCallback() {
        if (super.connectedCallback) super.connectedCallback();

        if (this.targets.item)
          this.on('click', this.targets.item.all, (event) => {
            if (this.targets.zoom && isFromBreakpoint('large')) {
              this.targets.zoom.open(event.currentTarget.dataset.id);
            }
          });
      }
    }
  );
